/** @prettier */

/**
 * API失敗時のエラーダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {PrimaryButton} from './BasicButton';

/**
 * API失敗時のエラーダイアログ
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - id ID
 */
const APIErrorMessage = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
}) => {
  /**
   * OKボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
  };

  const trans = useTranslation().t; //翻訳関数

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" style={{color: 'red'}}>
        {trans('APIErrorMessage.errorDlg.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText id="mv-processError-text" style={{color: 'red'}}>
          {trans('APIErrorMessage.errorDlg.msg')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans('APIErrorMessage.errorDlg.buttonTxt.ok')}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default APIErrorMessage;
